import { ApolloLink, HttpLink } from "@apollo/client"
import config from "../../config"
import { getAuthToken } from "../auth/authToken"
import { sentryErrorLink } from "../sentry"

const httpLink = new HttpLink({
  uri: config.API_ENDPOINTS.GRAPHQL,
  credentials: "include",
})

export const getApolloLink = () => {
  const middlewareLink = new ApolloLink((operation, forward) => {
    operation.setContext(() => {
      const authToken = getAuthToken()
      return { headers: { Authorization: authToken ? `Bearer ${authToken}` : "" } }
    })
    return forward(operation)
  })

  const httpLinkAuth = middlewareLink.concat(httpLink)

  return ApolloLink.from([sentryErrorLink, httpLinkAuth])
}
